<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('umsokn_samantekt_header') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>{{ t('umsokn_samantekt_header2') }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="application__summary">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-title>
                {{ t('umsokn_samantekt_upplysingar') }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <!-- Umsækjandi -->
                <div>
                  <Umsaekjandi
                    :umsokn="umsokn"
                    :disable="true"
                    :header="t('lan_greidslufrest_umsokn_step1_header')"
                  />
                </div>

                <!-- Meðskuldarar -->
                <div class="m-t-100">
                  <Step2 :umsokn="umsokn" :disable="true" />
                </div>

                <!-- Lán sem fresta skal -->
                <div class="m-t-100">
                  <Step3 :umsokn="umsokn" :disable="true" />
                </div>

                <!-- Ástæða -->
                <div class="m-t-100">
                  <Step4 :umsokn="umsokn" :disable="true" />
                </div>

                <!-- Lengd greiðslufrests -->
                <div class="m-t-100">
                  <Step5 :umsokn="umsokn" :disable="true" />
                </div>

                <!-- PEP (read-only in summary) -->
                <div class="m-t-100">
                  <PEP :showDisclamer="false" :umsokn="umsokn" :disable="true" />
                </div>

                <!-- Staðfesting & athugasemd -->
                <div class="m-t-100">
                  <Step6 :umsokn="umsokn" :disable="true" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

// child steps from this flow
import Umsaekjandi from '../../Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'
import Step6 from './Step6.vue'
import PEP from '../../Shared/PEP.vue'

type Umsokn = Record<string, any>

defineProps<{
  umsokn: Umsokn
  disable?: boolean
}>()

const { t } = useI18n()
</script>

<style scoped>
.forms__header { font-weight: 700; margin-bottom: 12px; }
.m-t-100 { margin-top: 40px; } /* keep generous spacing like legacy */
.application__summary :deep(.v-expansion-panel-title) { font-weight: 600; }
</style>
